<template>
  <div>
    <div class="d-flex justify-content-between p-3 p-sm-0 mb-3">
      <h1 class="mb-0 header-main text-uppercase d-inline">SETTING</h1>
      <button class="create-button">
        <div>
          <font-awesome-icon icon="plus-square" />
          <span class="ml-2"> CREATE</span>
        </div>
      </button>
    </div>
    <div class="bg-white-border p-3 text-black main-theme">
      <b-tabs content-class="mt-3">
        <b-tab title="Facebook Live" active>
          <ConnectFacebook />
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import ConnectFacebook from "./components/Connect.vue";
export default {
  components: {
    ConnectFacebook,
  },
};
</script>
